import { getApiUrl } from '../config/api.config';

export interface Category {
  id: string;
  name: string;
  description?: string;
  icon?: string;
  color?: string;
  parentId?: string;
  order: number;
  isActive: boolean;
  _count?: {
    Event: number;
  };
}

export interface CategoryResponse {
  success: boolean;
  data: Category[];
  message?: string;
}

class CategoryService {
  private baseUrl = 'categories';

  async getAllCategories(): Promise<Category[]> {
    try {
      const response = await fetch(getApiUrl(this.baseUrl), {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch categories');
      }

      const result: CategoryResponse = await response.json();
      return result.data || [];
    } catch (error) {
      console.error('Error fetching categories:', error);
      return [];
    }
  }

  async getActiveCategories(): Promise<Category[]> {
    const categories = await this.getAllCategories();
    return categories.filter(cat => cat.isActive);
  }
}

export const categoryService = new CategoryService();